<template>
  <div class="v-view chart-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>

    <v-chart
      v-if="barData.length > 0"
      ref="chart"
      class="cv-chart"
      :options="barOption"
      @mouseover="onMouseOver"
      @globalout="onGlobalOut"
      autoresize
    ></v-chart>
    <div v-else class="cv-nodata">暂无数据!</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { numToThousands } from '@/utils';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/tooltip';

export default {
  name: 'JCInstallation',
  computed: {
    ...mapGetters(['cid']),
    chart() {
      return this.$refs.chart && this.$refs.chart['chart'];
    },
  },
  props: {
    type: {
      type: String,
      default: 'line',
    },
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '各区县安装情况',
    },
  },
  watch: {
    barData(newData, oldData) {
      if (!newData || !newData.length) return;
      for (let i = 0; i < oldData.length; i++) {
        const newItem = newData[i];
        const oldItem = oldData[i];
        if (!newItem || newItem.Value !== oldItem.Value) {
          this.barOption.dataset.source = newData;
          break;
        }
      }
    },
  },
  data() {
    const installation = this.$configer.installation
    return {
      dataIndex: -1,
      dataInterval: null,
      barInterval: null,
      barOption: {
        grid: {
          top: '10%',
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#ffebe0',
              type:'solid'
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            rotate: 15,
            interval: 0,
            fontSize: 12,
            color: '#fff',
          },
          splitLine: {
            show: false,
            type:'solid'
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#ffebe0',
              
            },
          },
          axisLabel: {
            fontSize: 12,
            color: '#fff',
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#cbeaff',
              opacity: 0.3,
              type:'dashed'
            },
          },
        },
        legend: { show: false },
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: (params) => {
            const { data } = params[0];
            return `${data.Name}：${data.Value}`;
          },
        },
        dataset: {
          dimensions: ['Name', 'Value'],
          source: installation,
        },
        series: [
          {
            type: 'bar',
            name: '各区县安装情况统计',
            barMaxWidth: 15,
            label: {
              show: true,
              color:'#fff',
              position: 'top',
              formatter: (params) => {
                const { data } = params;
                // return numToThousands(data.Value);
                return data.Value;
              },
            },
            itemStyle: { color: '#00afe3' },
            encode: { x: 'Name', y: 'Value' },
          },
        ],
      },
      barData: [
        { Name: '普惠套餐', Value: 0 },
        { Name: '基础套餐', Value: 0 },
        { Name: '自选套餐', Value: 0 },
        { Name: '上门做饭', Value: 0 },
        { Name: '上门送餐', Value: 0 },
        { Name: '上门修脚', Value: 0 },
        { Name: '上门艾灸', Value: 0 },
        { Name: '上门足疗', Value: 0 },
        { Name: '上门助浴', Value: 0 },
        { Name: '上门问诊', Value: 0 },
        { Name: '上门送餐', Value: 0 },
        { Name: '其它项目', Value: 0 },
      ],
    };
  },
  created() {
  },
  mounted() {
    this.dataInterval = setInterval(() => {
    }, this.$interval * 2);
  },
  beforeDestroy() {
    if (this.dataInterval) {
      clearInterval(this.dataInterval);
      this.dataInterval = null;
    }
    if (this.barInterval) {
      clearInterval(this.barInterval);
      this.barInterval = null;
    }
  },
  methods: {
    onMouseOver() {
      if (this.barInterval) {
        clearInterval(this.barInterval);
        this.barInterval = null;
      }
    },
    onGlobalOut() {
      !this.barInterval && this.startAnimation();
    },
    startAnimation() {
      const dataLen = this.barData.length;
      if (dataLen > 1) {
        this.barInterval = setInterval(() => {
          if (this.dataIndex < dataLen - 1) {
            this.dataIndex++;
          } else {
            this.dataIndex = 0;
          }
          this.chart.dispatchAction({
            type: 'showTip',
            seriesIndex: 0,
            dataIndex: this.dataIndex,
          });
        }, 3000);
      }
    },
  },
};
</script>
